module.exports = __webpack_public_path__ + "img/43.cefd882c.jpg";